import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import DragAndDrop from './DragAndDrop';
import { useFileUploadMutation } from '../../trailerStatusEndpoints';

const DocumentUpload = ({ document, label, type, onUpload }) => {
  const [uploadError, setUploadError] = useState('');

  const [upload, { data = {}, error, isError, isLoading, isSuccess }] = useFileUploadMutation();
  const handleFileSelected = file => {
    setUploadError('');
    upload({ file, type });
  };

  const handleInvalidFile = result => {
    setUploadError(result.error);
    onUpload({ documentId: null });
  };

  const hasFile = R.not(R.isNil(document.documentId));

  useEffect(() => {
    if (isSuccess) onUpload(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isSuccess]);

  useEffect(() => {
    if (isError) setUploadError(error);
  }, [error, isError]);

  return (
    <DragAndDrop
      error={uploadError}
      isDone={hasFile}
      isLoading={isLoading}
      isRequired
      label={label}
      onFileSelected={handleFileSelected}
      onInvalidFile={handleInvalidFile}
      showDragZone={!hasFile}
    />
  );
};

DocumentUpload.propTypes = {
  document: PropTypes.shape({
    documentId: PropTypes.string,
  }),
  label: PropTypes.oneOf(['Wet Test', 'Method27']).isRequired,
  onUpload: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['WT', 'M27']).isRequired,
};

DocumentUpload.defaultProps = {
  document: { documentId: null },
};

export default DocumentUpload;
